<span class="inline-title-button-container">
  <ng-content></ng-content>
  <button mat-button [attr.aria-label]="tooltipTextKey | translate" [matTooltip]="tooltipTextKey | translate" (click)="onClick()">
    <img src="/assets/images/download.svg" alt="Download Data" class="download-icon" />
  </button>
</span>
